import component from './NoneStyleButton';

export default component;
